// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"239de51c","952":"c4076476"}[chunkId] + ".chunk.js";
};